(() => {
    HuiNavBadgeController.$inject = ['$scope'];

    function HuiNavBadgeController($scope) {
        const self = this;
    }

    angular
        .module("harriApp")
        .directive("huiNavBadge", function () {
            return {
                restrict: 'E',
                replace: true,
                scope: true,
                bindToController: {
                    content: '@',
                },
                controllerAs: '$ctrl',
                controller: HuiNavBadgeController,
                template: `<div class="nav-badge text-white">
                               {{$ctrl.content}}
                           </div>`
            }
        });

})();